import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { SalaryPermissionModel } from "@/model/user/ApplicationPermissionModel";

export function DefineSalaryPermissionAbility(salaryPermission: SalaryPermissionModel, can: any) {
  const { paySalary, summarySalary, payment, accessToPeak }: SalaryPermissionModel = salaryPermission ?? {};

  paySalary?.view && can(AbilityAction.Access, AbilitySubject.ViewPaySalary);
  paySalary?.create && can(AbilityAction.Create, AbilitySubject.CreatePaySalary);
  paySalary?.edit && can(AbilityAction.Update, AbilitySubject.EditPaySalary);
  paySalary?.delete && can(AbilityAction.Update, AbilitySubject.DeletePaySalary);
  paySalary?.approve && can(AbilityAction.Update, AbilitySubject.ApprovePaySalary);

  summarySalary?.view && can(AbilityAction.Access, AbilitySubject.ViewSummarySalary);
  summarySalary?.create && can(AbilityAction.Create, AbilitySubject.CreateSummarySalary);
  summarySalary?.edit && can(AbilityAction.Update, AbilitySubject.EditSummarySalary);
  summarySalary?.delete && can(AbilityAction.Update, AbilitySubject.DeleteSummarySalary);
  summarySalary?.approve && can(AbilityAction.Update, AbilitySubject.ApproveSummarySalary);

  payment?.payment && can(AbilityAction.Update, AbilitySubject.Payment);

  accessToPeak?.createDailyJournal && can(AbilityAction.Update, AbilitySubject.RecordDailyJournal);
}
